import React, { Component } from 'react';
import { 
  Box, 
  Typography, 
  Button, 
  IconButton, 
  TextField, 
  Paper,
  List,
  ListItem,
  ListItemText,
  ListItemSecondaryAction
} from '@material-ui/core';
import { 
  CloudUpload as UploadIcon, 
  Delete as DeleteIcon,
  AttachFile as AttachIcon 
} from '@material-ui/icons';

class OptionalAttachments extends Component {
  constructor(props) {
    super(props);
    this.state = {
      attachments: []
    };
  }

  handleFileSelect = (event) => {
    const files = Array.from(event.target.files);
    
    files.forEach(file => {
      // Check file size (limit to 10MB per file)
      if (file.size > 10 * 1024 * 1024) {
        alert(`Tiedosto ${file.name} on liian suuri. Maksimikoko on 10MB.`);
        return;
      }

      // Check file type (allow common document formats)
      const allowedTypes = [
        'application/pdf',
        'image/jpeg',
        'image/png',
        'image/gif',
        'application/msword',
        'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
        'application/vnd.ms-excel',
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        'text/plain'
      ];

      if (!allowedTypes.includes(file.type)) {
        alert(`Tiedostotyyppi ${file.type} ei ole tuettu. Tuetut tiedostotyypit: PDF, Word, Excel, kuvat (JPG, PNG, GIF), TXT.`);
        return;
      }

      const newAttachment = {
        id: Date.now() + Math.random(),
        file: file,
        description: '',
        fileName: file.name,
        fileSize: file.size
      };

      this.setState(prevState => ({
        attachments: [...prevState.attachments, newAttachment]
      }), () => {
        // Notify parent component of changes
        if (this.props.onAttachmentsChange) {
          this.props.onAttachmentsChange(this.state.attachments);
        }
      });
    });

    // Clear the input so the same file can be selected again if needed
    event.target.value = '';
  };

  handleDescriptionChange = (attachmentId, description) => {
    this.setState(prevState => ({
      attachments: prevState.attachments.map(att => 
        att.id === attachmentId ? { ...att, description } : att
      )
    }), () => {
      // Notify parent component of changes
      if (this.props.onAttachmentsChange) {
        this.props.onAttachmentsChange(this.state.attachments);
      }
    });
  };

  handleRemoveAttachment = (attachmentId) => {
    this.setState(prevState => ({
      attachments: prevState.attachments.filter(att => att.id !== attachmentId)
    }), () => {
      // Notify parent component of changes
      if (this.props.onAttachmentsChange) {
        this.props.onAttachmentsChange(this.state.attachments);
      }
    });
  };

  formatFileSize = (bytes) => {
    if (bytes === 0) return '0 Bytes';
    const k = 1024;
    const sizes = ['Bytes', 'KB', 'MB', 'GB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
  };

  render() {
    const { attachments } = this.state;
    const { loanType } = this.props;
    
    // Check if this is invoice financing (loanApplicationLoanTypeEnum: 5)
    const isInvoiceFinancing = loanType === 5;

    return (
      <Box mt={2}>
        <Typography variant="h6" gutterBottom>
          Liitteet (valinnainen)
        </Typography>
        <Typography variant="body2" color="textSecondary" style={{ marginBottom: '12px' }}>
          {isInvoiceFinancing 
            ? 'Liitä väliajo tai esimerkkilaskuja, niin voimme käsitellä hakemuksesi nopeammin.'
            : 'Liitä väliajo tai muu tukidokumentti, niin voimme käsitellä hakemuksesi nopeammin.'
          }
        </Typography>

        <Box mb={2}>
          <input
            accept=".pdf,.doc,.docx,.xls,.xlsx,.jpg,.jpeg,.png,.gif,.txt"
            style={{ display: 'none' }}
            id="file-upload-input"
            type="file"
            multiple
            onChange={this.handleFileSelect}
          />
          <label htmlFor="file-upload-input">
            <Button
              variant="outlined"
              component="span"
              startIcon={<UploadIcon />}
              color="primary"
            >
              Valitse tiedostot
            </Button>
          </label>
        </Box>

        {attachments.length > 0 && (
          <Paper variant="outlined" style={{ marginTop: 16 }}>
            <List>
              {attachments.map((attachment, index) => (
                <ListItem key={attachment.id} divider={index < attachments.length - 1}>
                  <AttachIcon style={{ marginRight: 16, color: '#666' }} />
                  <Box flexGrow={1}>
                    <Typography variant="body2" fontWeight="medium">
                      {attachment.fileName}
                    </Typography>
                    <Typography variant="caption" color="textSecondary">
                      {this.formatFileSize(attachment.fileSize)}
                    </Typography>
                    <TextField
                      fullWidth
                      variant="outlined"
                      size="small"
                      placeholder={
                        isInvoiceFinancing 
                          ? "Kuvaile tiedosto (esim. 'väliajo 1-6/2024' tai 'esimerkkejä samankaltaisista laskuista')"
                          : "Kuvaile tiedosto (esim. 'väliajo 1-6/2024' tai 'toimintasuunnitelma')"
                      }
                      value={attachment.description}
                      onChange={(e) => this.handleDescriptionChange(attachment.id, e.target.value)}
                      style={{ marginTop: 8 }}
                      inputProps={{ maxLength: 200 }}
                    />
                  </Box>
                  <ListItemSecondaryAction>
                    <IconButton 
                      edge="end" 
                      onClick={() => this.handleRemoveAttachment(attachment.id)}
                      color="secondary"
                    >
                      <DeleteIcon />
                    </IconButton>
                  </ListItemSecondaryAction>
                </ListItem>
              ))}
            </List>
          </Paper>
        )}

        {attachments.length > 0 && (
          <Typography variant="caption" color="textSecondary" mt={2} display="block">
            Yhteensä {attachments.length} tiedosto(a) valittu
          </Typography>
        )}
      </Box>
    );
  }
}

export default OptionalAttachments;
